import classes from './TaskMessages.module.css'

export default function TaskMessages({itemData}) {
    return <div className={classes.padded_cell}>
        {itemData.note}
        {itemData.assignee_resolved_note && <div className={classes.item_resolved}>
            <strong>Resolved by</strong> {itemData.assignee_resolved_by?.name} <strong>with note </strong> {itemData.assignee_resolved_note}   
        </div>}
        {itemData.resolved_note && <div className={classes.item_resolved}>
            <strong>Resolved Message </strong> {itemData.resolved_note}   
        </div>}
        
    </div>
}